import { render, staticRenderFns } from "./FactorGroupList.vue?vue&type=template&id=35437608&scoped=true&"
import script from "./FactorGroupList.vue?vue&type=script&lang=js&"
export * from "./FactorGroupList.vue?vue&type=script&lang=js&"
import style0 from "./FactorGroupList.vue?vue&type=style&index=0&id=35437608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35437608",
  null
  
)

export default component.exports